module.exports = __webpack_public_path__ + "img/btn-1.f84187f3.png";